// The floating AI assistant launcher is intentionally disabled.
// Product help remains available from the persistent "Guida" entry in the sidebar.
// Keeping this component as a no-op avoids changing App wiring while ensuring
// no fixed overlay can cover the editor or project UI.
export default function AssistantWidget() {
  return null;
}
